import React from "react";
import { TextField, useTheme } from "@mui/material";
import { useDarkMode } from "../../../../../hooks/useDarkMode";

interface NameFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  disabled?: boolean;
}

export const NameField: React.FC<NameFieldProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const theme = useTheme();
  const { customColorPalette: palette } = theme;
  const isDarkMode = useDarkMode();

  return (
    <TextField
      fullWidth
      label="Name"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: isDarkMode ? palette.gray[800] : "#FFFFFF",
          color: isDarkMode ? palette.gray.A100 : palette.gray[900],
        },
      }}
    />
  );
};
